import React from 'react';
import { useLocation } from 'react-router-dom';
import { Typography } from '@naf-simba/building-blocks-typography';
import { useResolvedNavigationLink } from '../../../hooks/useResolvedNavigationLink';
import { HighlightedLinksType } from '../../../../../types/globalSettingsType';
import { useHandleNavigationClick } from '../../../utils/Tracking/Navigation/NavigationTracking';
import * as S from './MobileMenuLink.styles';

interface MobileHighlightedLinkProps {
  item?: HighlightedLinksType | null;
}

export const MobileHighlightedLink = ({ item }: MobileHighlightedLinkProps) => {
  const location = useLocation();
  const link = item?.link;
  const { url, blank } = useResolvedNavigationLink({
    data: link?.link?.data,
    type: link?.link?.type,
  });

  const handleOnClick = useHandleNavigationClick({
    event: 'mobileHighlightedLinkClick',
    menuPage: location.pathname,
    menuSectionName: 'highlightedLinkMobile',
    menuItemName: link?.header ?? '',
    menuItemUrl: url,
  });

  if (!link?.header || !url) return null;

  return (
    <S.HighlightedLinkItem url={url} blank={blank} onClick={handleOnClick}>
      <Typography>{link.header}</Typography>
    </S.HighlightedLinkItem>
  );
};
